import { USER_EMAILS_ENTITY } from '../../../constants/entity'
import { EntityTabEmails } from '../../EntityTab'
import { useUserProfileContext } from '../../User'

import { USER_PROFILE_TAB_EMAILS_QA_NAME } from './UserProfileTabEmails.constants'

function UserProfileTabEmails({
  userData,
  onClickAddEmail,
  onReloadTabCounters,
}) {
  const { registerEmailsTabReload } = useUserProfileContext()

  return (
    <EntityTabEmails
      entity={USER_EMAILS_ENTITY}
      qaName={USER_PROFILE_TAB_EMAILS_QA_NAME}
      scopeId={userData?.id}
      onClickAdd={onClickAddEmail}
      onRegisterReload={registerEmailsTabReload}
      onReloadCounters={onReloadTabCounters}
    />
  )
}

export default UserProfileTabEmails
